export const TOGGLE_MENU = "layout:toggleMenu";

export function toggleMenu(open) {
  return {
    type: TOGGLE_MENU,
    payload: open
  };
}